var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("mail-settings")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-mail-settings", {
                    attrs: {
                      "use-ids": "",
                      fancy: "",
                      label: _vm.$ct("default-mail-settings"),
                      "add-empty-value": "",
                      "empty-text": _vm.mailSettingsDefaultText,
                    },
                    model: {
                      value: _vm.userConfig.DefaultMailSettingsID,
                      callback: function ($$v) {
                        _vm.$set(_vm.userConfig, "DefaultMailSettingsID", $$v)
                      },
                      expression: "userConfig.DefaultMailSettingsID",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-sale-email-template", {
                    attrs: {
                      label: _vm.$ct("email-template-default"),
                      fancy: "",
                      "has-null": "",
                      "use-ids": "",
                    },
                    model: {
                      value: _vm.config.DefaultEmailTemplateID,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DefaultEmailTemplateID", $$v)
                      },
                      expression: "config.DefaultEmailTemplateID",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-sale-email-template", {
                    attrs: {
                      label: _vm.$ct("email-client-portal-template-default"),
                      fancy: "",
                      "has-null": "",
                      "use-ids": "",
                    },
                    model: {
                      value: _vm.config.DefaultPortalEmailTemplateID,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config,
                          "DefaultPortalEmailTemplateID",
                          $$v
                        )
                      },
                      expression: "config.DefaultPortalEmailTemplateID",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    class: { error: _vm.showExtraBCCAddressValidError },
                    attrs: { label: _vm.$ct("extra-bcc-address"), fancy: "" },
                    on: {
                      focus: function ($event) {
                        _vm.isExtraBCCAddressFocused = true
                      },
                      blur: function ($event) {
                        _vm.isExtraBCCAddressFocused = false
                      },
                    },
                    model: {
                      value: _vm.config.ExtraBCCAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "ExtraBCCAddress", $$v)
                      },
                      expression: "config.ExtraBCCAddress",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("additional-bcc-address"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.config.AdditionalBCCAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "AdditionalBCCAddress", $$v)
                      },
                      expression: "config.AdditionalBCCAddress",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-sale-type-edit-general-print-after-send", {
                    attrs: { config: _vm.config },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }